var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiCardHeader from "@material-ui/core/CardHeader";
import { useCardContext } from "../card";
import { defaultCardSize } from "../card/card-context";
import { makeStyles, styled } from "../styles";
import { compose, display, flexbox, grid, sizing, spacing, } from "../system";
import { Text } from "../text";
import clsx from "../utils/clsx";
var SystemCardHeader = styled(MuiCardHeader)(compose(display, grid, sizing, spacing, flexbox));
var titleVariantMap = {
    small: "subtitle2",
    medium: "subtitle2",
    large: "subtitle1",
    xlarge: "subtitle1",
};
var CardHeaderComponentName = "CosmosCardHeader";
var useCardHeaderStyles = makeStyles(function (theme) { return ({
    title: {
        marginBottom: theme.spacing(0.5),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    titleMarginDense: {
        marginBottom: theme.spacing(0.25),
    },
    action: {},
    avatar: {},
    avatarSizeSmall: {
        paddingTop: 2,
    },
    avatarSizeLarge: {
        paddingTop: 5,
    },
}); }, { name: CardHeaderComponentName });
export var CardHeader = React.forwardRef(function (props, ref) {
    var _a;
    var sizeContext = useCardContext().size;
    var classes = useCardHeaderStyles(props);
    var sizeProp = props.size, _b = props.titleTypographyProps, titleTypographyProps = _b === void 0 ? {} : _b, _c = props.subheaderTypographyProps, subheaderTypographyProps = _c === void 0 ? {} : _c, title = props.title, subheader = props.subheader, 
    // don't forward on to the root
    classesProp = props.classes, cardProps = __rest(props, ["size", "titleTypographyProps", "subheaderTypographyProps", "title", "subheader", "classes"]);
    var size = sizeProp || sizeContext || defaultCardSize;
    var titleVariant = titleVariantMap[size];
    return (React.createElement(SystemCardHeader, __assign({}, cardProps, { classes: {
            avatar: clsx(classes.avatar, (_a = {},
                _a[classes.avatarSizeLarge] = size === "large" || size === "xlarge",
                _a[classes.avatarSizeSmall] = size === "small",
                _a)),
            action: classes.action
        }, disableTypography: true, title: React.createElement(Text, __assign({ variant: titleVariant, color: "textPrimary", component: "h2", display: "block" }, titleTypographyProps, { className: clsx(classes.title, size === "small" && classes.titleMarginDense, titleTypographyProps.className) }), title), subheader: subheader ? (React.createElement(Text, __assign({ variant: "body2", color: "textSecondary", component: "p" }, subheaderTypographyProps), subheader)) : null, titleTypographyProps: __assign({ variant: titleVariant }, titleTypographyProps), ref: ref })));
});
